import { svg } from 'lit';

export const filterFilledIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.00001 2C2.6224 2 2.27699 2.2127 2.10703 2.5499C1.93707 2.8871 1.97154 3.29128 2.19615 3.59482L9.00001 12.7897V19C9.00001 19.3788 9.21401 19.725 9.55279 19.8944L13.5528 21.8944C13.8628 22.0494 14.2309 22.0329 14.5257 21.8507C14.8206 21.6684 15 21.3466 15 21V12.7897L21.8039 3.59482C22.0285 3.29128 22.0629 2.8871 21.893 2.5499C21.723 2.2127 21.3776 2 21 2H3.00001Z" fill="currentColor"/>
  `;
